var map = {
	"./detalleProducto/transpaletaCBY.png": 46,
	"./detalleProducto/transpaletaEP-55.png": 47,
	"./detalleProducto/transpaletaparapasillo.png": 48,
	"./transpaleta1.jpg": 49,
	"./transpaleta2.jpg": 50,
	"./transpaleta3.jpg": 51,
	"./transpaleta5.jpg": 52,
	"./transpaleta7.2.jpg": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;